<template>
<div id="header" class="load">

<!-- 
  <div class="topMenu">
<div class="leftside">
  <img src="/static/images/common/logo_damda.png" alt="담다" class="logo logoWhite">
  <img src="/static/images/common/DAMDA_logo.png" alt="담다" class="logo logoColor">
  <nav class="menu-box-1">
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">DAMDA</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/about/bigdataflatform" >빅데이터 플랫폼</router-link></li>
          <li><router-link to="/about/services" >지원서비스</router-link></li>
        </ul>
      </li>
    </ul>
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">기업협의회</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/partner" >기업협의회 소개</router-link></li>
          <li><router-link to="/partner" >기업협의회 가입신청</router-link></li>
        </ul>
      </li>
    </ul>
    <ul class = "navbar-nav">
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">다운로드</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/download/sdk" >SDK 다운로드</router-link></li>
          <li><router-link to="/download/template" >모바일 템플릿앱 다운로드</router-link></li>
          <li><router-link to="/download/Vue" >자료실</router-link></li>
        </ul>
      </li>
    </ul>
    
      <li class = "nav-item"><a class="nav-link dropdown-toggle" href="javascript:" @click="navbar_onoff()">고객센터</a>
        <ul class="dropdown-menu" id = "dropdown-menu">
          <li><router-link to="/support/notice" >공지사항</router-link></li>
          <li><router-link to="/support/faq" >자주 묻는 질문</router-link></li>
          <li><router-link to="/support/qna" >고객문의</router-link></li>
        </ul>
      </li>
  </nav>
</div>
    </div>

    <div class="topMenu rightside">
        <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
        <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
        <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
        <a href="javascript:" class="noborder" v-if="isAuthenticated"><span v-text="userName"></span> 님 환영합니다.</a>
        <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
        <a href="javascript:" class="portal" v-if="isAuthenticated" @click="checkPortal()">포탈</a>
      </div>

 -->



   <div class="headerTop clearfix">
     <div class="headerTop_left">
      <p></p>
    </div>

    <div class="headerTop_right">
      <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
      <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
      <a href="javascript:" class="noborder" v-if="isAuthenticated"><span v-text="userName"></span> 님 환영합니다.</a>
      <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
      <div
        class="platform-application-menu"
        ref="platformApplicationMenu"
        :class="{ 'is-open': isPlatformApplicationMenuOpen }"
      >
        <button
          class="platform-application-trigger"
          type="button"
          aria-haspopup="true"
          :aria-expanded="isPlatformApplicationMenuOpen.toString()"
          @click="togglePlatformApplicationMenu"
          @keydown.esc="closePlatformApplicationMenu"
        >플랫폼 활용신청</button>
        <div class="platform-application-options">
          <router-link to="/platform-application/iot" :tabindex="isPlatformApplicationMenuOpen ? 0 : -1" @click.native="closePlatformApplicationMenu">IoT·데이터 상담</router-link>
          <router-link to="/platform-application/bigdata" :tabindex="isPlatformApplicationMenuOpen ? 0 : -1" @click.native="closePlatformApplicationMenu">빅데이터 분석 의뢰</router-link>
        </div>
      </div>
      <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
      <a href="javascript:" class="portal" @click="checkPortal()">포탈</a>
    </div>
   </div>
   <div class="headerBot">
     <h1>
       <a href="/" class="logo"><img src="/static/images/common/logo_damda.png" alt="담다" class="logo_white"><img src="/static/images/common/DAMDA_logo.png" alt="" class="logo_color"></a>
     </h1>
    <a href="javascript:" class="btn_all_menu">
      <span class="barTop"></span>
      <span class="barMid"></span>
      <span class="barBot"></span>
    </a>

   </div>
    <div class="allMenuWrap winH" style="height: 941px;">
    <div class="allMenuTop">
      <a href="index.html"><img src="/static/images/common/logo_gray.png" alt="" class="logo_menu"></a>
      <a href="" class="close_menu">메뉴 닫기</a>
    </div>
    <div class="allMenuWrap_inner">
      <div class="allMenu_inner">

        <ul class="allMenu clearfix">
          <li class="hasDep2">
            <a href="">DAMDA 소개</a>
            <ul class="dep2">
              <li ><router-link to="/about/bigdataflatform" >빅데이터 플랫폼</router-link></li>
              <li ><router-link to="/about/services" >지원서비스</router-link></li>
            </ul>
          </li>
           <li class="hasDep2">
            <a href="">기업협의회</a>
            <ul class="dep2">
              <li ><router-link to="/partner" >기업협의회 소개</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">플랫폼 활용신청</a>
            <ul class="dep2">
              <li><router-link to="/platform-application/iot">IoT·데이터 상담</router-link></li>
              <li><router-link to="/platform-application/bigdata">빅데이터 분석 의뢰</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">다운로드</a>
            <ul class="dep2">
              <li ><router-link to="/download/sdk" >SDK 다운로드</router-link></li>
              <li ><router-link to="/download/template" >모바일 템플릿앱 다운로드</router-link></li>
              <li><router-link to = "/download/Vue" >자료실</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">이용안내</a>
            <ul class="dep2">
              <li ><router-link to="/support/notice" >공지사항</router-link></li>
              <li ><router-link to="/support/faq" >FAQ</router-link></li>
              <li ><router-link to="/support/qna" >1:1문의</router-link></li>
            </ul>
          </li>
          <li class="hasDep2">
            <a href="">마이페이지</a>
            <ul class="dep2">
              <li><router-link to="/my/info" >회원정보관리</router-link></li>
              <li><router-link to="/my/qna" >1:1문의내역</router-link></li>
            </ul>
          </li>
        </ul>
         <div class="btn_family">
          <a href="/web/main" class="to_login" v-if="!isAuthenticated">로그인</a>
          <router-link to="/member/regist" class="to_joinin" v-if="!isAuthenticated">회원가입</router-link>
          <a href="javascript:" class="loginTxt" v-if="isAuthenticated"><span>{{ userName }}</span> 님 환영합니다.</a>
          <a href="javascript:" class="to_joinin" v-if="isAuthenticated" @click="logoutAndRedirect()">로그아웃</a>
          <router-link to="/partner#apply" class="to_request">기업협의회 가입신청</router-link>
          <a href="javascript:" class="portal" @click="checkPortal()">포탈</a>
        </div>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_portal"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_hura"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_bai"></iframe>
        <iframe width=0 height=0 frameborder=0 src="" id="resiframe_ey"></iframe>
      </div>
    </div>
  </div>
  <div class="allMenuWrap_dim winH" style="height: 891px;"></div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'main-header',
  data () {
    return {
      isPlatformApplicationMenuOpen: false
    }
  },
  methods: {
    ...mapActions([ 'logout' ]),
    logoutAndRedirect () {
      if (!confirm('로그아웃 하시겠습니까?')) return
      // 로그아웃 iframe 은 기다리지 않는다(DAM-854). 이동으로 끊기거나 빈 AUTH_SESSIONID 가 남아도
      // DARP 는 부모 로그인 확인 뒤에만 OAuth 를 시작하므로 어스 로그인 화면이 뜨지 않는다.
      const frame = id => document.getElementById(id)
      frame('resiframe').src = process.env.LANDING_LOGOUT_URL
      frame('resiframe_portal').src = process.env.PORTAL_LOGOUT_URL
      frame('resiframe_hura').src = process.env.HURA_LOGOUT_URL
      // userId 는 logout() 이 store 를 비우기 전에 읽어야 한다.
      frame('resiframe_bai').src = process.env.BAI_LOGOUT_URL.replace('{{userId}}', this.userId)
      frame('resiframe_ey').src = process.env.EY_LOGOUT_URL
      this.logout().then(() => {
        window.location.href = '/'
      })
    },
    checkPortal () {
      if (this.isAuthenticated && this.isCertUser) {
        location.href = process.env.PORTAL_URL
      } else if (this.isAuthenticated && !this.isCertUser) {
        alert('기업협의회에 가입해야 사용 가능합니다.')
      } else {
        alert('로그인 후 이용 가능합니다.')
        window.location.href = '/web/main?goto=portal'
      }
    },
    togglePlatformApplicationMenu () {
      this.isPlatformApplicationMenuOpen = !this.isPlatformApplicationMenuOpen
    },
    closePlatformApplicationMenu () {
      this.isPlatformApplicationMenuOpen = false
    },
    // 버튼과 항목 사이 틈을 지날 때 닫히지 않도록 hover 가 아니라 바깥 클릭으로만 닫는다.
    closePlatformApplicationMenuOnOutsideClick (event) {
      const menu = this.$refs.platformApplicationMenu
      if (menu && !menu.contains(event.target)) {
        this.closePlatformApplicationMenu()
      }
    },
    navbar_onoff () {
      var nav_dropdown_menu = document.getElementById('dropdown-menu');
      
      if(nav_dropdown_menu.className == 'dropdown-menu') {
        nav_dropdown_menu.className = 'dropdown-menu show';
      } else if(nav_dropdown_menu.className == 'dropdown-menu show'){
        nav_dropdown_menu.className = 'dropdown-menu';
      }
    }
  },
  computed: {
    ...mapState({
      userName: state => state.auth.userInfo.name,
      isAuthenticated: state => state.auth.userInfo,
      isCertUser: state => state.auth.userInfo.org_cd,
      userId: state => state.auth.userInfo.user_id
    })
  },
  mounted () {
    document.addEventListener('click', this.closePlatformApplicationMenuOnOutsideClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closePlatformApplicationMenuOnOutsideClick)
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.allMenuWrap .btn_family a.portal, #header .headerTop_right a.portal {
  color: #4385f5;
  border: 1px solid #4385f5;
}
#header .headerTop a.noborder {
  border: none;
}
.platform-application-menu {
  display: inline-block;
  margin-left: 4px;
  position: relative;
  vertical-align: top;
}
#header .headerTop .platform-application-trigger {
  background: transparent;
  border: 1px solid #fff;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: block;
  font-size: 14px;
  height: 34px;
  line-height: 32px;
  padding: 0 20px;
  transition: all .2s ease-in-out;
  white-space: nowrap;
  width: 100%;
}
#header .headerTop .platform-application-trigger:hover,
#header .headerTop .platform-application-trigger:focus {
  background-color: rgba(67, 133, 245, .4);
  outline: none;
}
/* 문서 흐름에 남겨 메뉴 너비 = max(버튼, 가장 긴 항목). height 0이라 헤더 높이는 그대로 */
.platform-application-options {
  height: 0;
  opacity: 0;
  pointer-events: none;
  position: relative;
  top: 4px;
  transform: translateY(-6px);
  transition: opacity .2s ease-in-out, transform .2s ease-in-out, visibility .2s;
  visibility: hidden;
  z-index: 1;
}
.platform-application-menu.is-open .platform-application-options {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0);
  visibility: visible;
}
#header .headerTop .platform-application-options a {
  background-color: transparent;
  display: block;
  margin: 0 0 4px;
  text-align: center;
  white-space: nowrap;
  width: 100%;
}
#header.scroll .platform-application-trigger {
  border-color: #b7b7b7 !important;
  color: #444 !important;
}
#header.scroll .headerTop .platform-application-options a {
  background-color: #f1f2f5;
}
</style>



// WEBPACK FOOTER //
// src/components/include/MainHeader.vue